import toast from "react-hot-toast";

const toasty = {
	error(label, error) {
		const serverMessage =
			error?.response?.data?.message ||
			error?.response?.data?.error ||
			error?.message;

		toast.error(
			serverMessage
				? (label ? label + ": " : "") + serverMessage
				: label || "An error occurred"
		);
	},
	success(label) {
		toast.success(label);
	},
	warn(label, error) {
		const serverMessage =
			error?.response?.data?.message ||
			error?.response?.data?.error ||
			error?.message;

		toast(
			serverMessage
				? (label ? label + ": " : "") + serverMessage
				: label || "",
			{ icon: "⚠️" }
		);
	},
	info(label) {
		toast(label, { icon: "ℹ️" });
	},
};

export default toasty;
